'use client';

import { MouseEventHandler, useState } from 'react';

export const useButtonLoadingState = (onClick?: MouseEventHandler<HTMLButtonElement>) => {
  const [waiting, setWaiting] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = async (e) => {
    try {
      setWaiting(true);
      // oxlint-disable-next-line @typescript-eslint/await-thenable
      await onClick?.(e);
    } finally {
      setWaiting(false);
    }
  };

  return { waiting, handleClick };
};
